/**
 * Created by Carsten Bühler
 * User: CBuehler on 17.11.2015
 * Copyright: xdot GmbH 2015
 */

import { Client } from 'external/lwr-client';
import { ApiUtil } from 'plugin/liferay-widgets-react-web';

const stateService = (m, o) => Client.invoke('/state.state/' + m, o);
const stateServiceWithContext = (m, o, c) => Client.invokeWithContext('/state.state/' + m, o, c);

let api = {

    loadStatesFromService() {
        return stateServiceWithContext('list-all.1');
    },

    loadStateFromService(id) {
        return stateService('get.1', {
            id: id
        });
    },

    addState(data) {
        return stateServiceWithContext('add.1',
            {},
            {
                className: parseInt(data.className),
                stateTitle: data.stateTitle,
                stateKey: data.stateKey,
                description: data.description,
                style: data.style
            });
    },

    editState(data) {
        return stateServiceWithContext('update.2',
            {
                id: data.id
            },
            {
                className: parseInt(data.className),
                stateTitle: data.stateTitle,
                stateKey: data.stateKey,
                description: data.description,
                style: data.style
            });
    }
};

ApiUtil.namedApi('StateWebApi', api);

export default api;



// WEBPACK FOOTER //
// ./js/webapi/StateWebApi.js